import { Link } from "react-router-dom";
import { FileText, MessageSquare } from "lucide-react";
import { useRecent } from "@/api/hooks";
import { PageHeader, EmptyState, ErrorState, SectionTitle } from "@/components/States";
import { NoteRow } from "@/components/NoteRow";
import { ThreadCard } from "@/components/ThreadCard";
import { PageSkeleton } from "@/components/ui/skeleton";

export default function RecentPage() {
  const recent = useRecent();

  if (recent.isLoading) return <PageSkeleton />;
  if (recent.isError) return <ErrorState error={recent.error} retry={() => recent.refetch()} />;
  const { threads, notes } = recent.data!;

  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader title="Recent" description="Latest conversations and the notes they changed." />

      <section className="mb-8">
        <SectionTitle
          action={
            <Link to="/threads" className="text-xs text-link hover:underline">
              All threads
            </Link>
          }
        >
          Threads
        </SectionTitle>
        {threads.length === 0 ? (
          <EmptyState
            icon={MessageSquare}
            title="No threads yet"
            description={
              <>
                Threads appear when a client writes notes over MCP.{" "}
                <Link to="/settings/connect" className="text-link underline-offset-2 hover:underline">
                  Connect a client
                </Link>{" "}
                to get started.
              </>
            }
          />
        ) : (
          <div className="flex flex-col">
            {threads.slice(0, 8).map((t) => (
              <ThreadCard key={t.id} thread={t} />
            ))}
          </div>
        )}
      </section>

      <section>
        <SectionTitle>Recently changed notes</SectionTitle>
        {notes.length === 0 ? (
          <EmptyState icon={FileText} title="No notes yet" description="Create one from a space, or let a model write the first one." />
        ) : (
          <div className="flex flex-col">
            {notes.slice(0, 20).map((n) => (
              <NoteRow key={n.id} note={n} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
